import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { UserStory } from 'src/types/epic';
import Loader from 'src/components/loader';
import { User } from 'src/types/user';
import { Platform } from 'src/types/constants';
import { useGetUserstories, useUpdateUserstories } from 'src/queries/userstory';
import { UserStoryItem } from './userStory';
import React from 'react';

export default function EpicsPage() {
  const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}");
  const user: User = JSON.parse(Cookies.get('user') || '{}');
  const navigate = useNavigate();
  const { data, error, isLoading, isFetching } = useGetUserstories();
  const { mutate: assignRequest, data: assignResult } = useUpdateUserstories();

  const [assignedStory, setAssignedStory] = useState<UserStory | null>(null);
  const [firstUnassigned, setFirstUnassigned] = useState<UserStory | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // Check if user already has a story
  useEffect(() => {
    if (data?.length) {
      const myStory = data.find(story => story.assigned_to === user.id);
      const unassignedStory = data.find(story => !story.assigned_to);
      setAssignedStory(myStory || null);
      setFirstUnassigned(unassignedStory || null);
    }
  }, [data, user.id]);

  // Redirect after assigning a story
  useEffect(() => {
    if (assignResult) {
      navigate(`/epics/${assignResult?.epics[0].id}`);
    }
  }, [assignResult, navigate]);

  useEffect(() => {
    if (error) {
      toast(JSON.stringify(error));
    }
  }, [error]);

  // Open confirmation modal
  const handlePickCard = () => {
    if (!firstUnassigned) {
      toast("No unassigned cards available");
      return;
    }
    setShowConfirmModal(true);
  };

  // Confirm assigning first unassigned story
  const handleConfirmAssign = () => {
    if (!firstUnassigned) return;
    assignRequest({
      id: firstUnassigned.id,
      userId: user.id.toString(),
      version: firstUnassigned.version,
    });
    setShowConfirmModal(false);
  };

  return (
      <div className="pt-5">
        <h1 className="title mb-2">{platform?.name}</h1>

        {/* If user already has a story, show it */}
        {assignedStory ? (
            <ul className="menu bg-base-100 w-full rounded-box">
              <li key={assignedStory.id} className="border-2 bg-blue-50">
                <UserStoryItem
                    userstory={assignedStory}
                    userstories={[assignedStory]}
                    clickHandler={() => navigate(`/epics/${assignedStory.epics[0].id}`)}
                />
              </li>
            </ul>
        ) : (
            // Otherwise show button to pick card
            <div className="flex flex-col items-center my-10">
              <p>شما در حال حاضر هیچ کارتی برای انجام ندارید.</p>
              <button className="btn btn-primary mt-4" onClick={handlePickCard}>
                کارت میخواهید؟
              </button>
            </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && firstUnassigned && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg w-96 p-6 shadow-lg">
                <p>مطمئن هستید؟</p>
                <div className="mt-6 flex justify-end gap-4">
                  <button
                      className="btn btn-outline"
                      onClick={() => setShowConfirmModal(false)}
                  >
                    خیر
                  </button>
                  <button className="btn btn-primary" onClick={handleConfirmAssign}>
                    بلی
                  </button>
                </div>
              </div>
            </div>
        )}

        {(isLoading || isFetching) && <Loader />}
      </div>
  );
}
